import { useRegisterSW } from 'virtual:pwa-register/react';

export function PWAUpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered:', r);
    },
    onRegisterError(error) {
      console.error('SW registration error', error);
    }
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  const updateAndReload = () => {
    updateServiceWorker(true);
  };

  if (offlineReady) {
    return (
      <div className="fixed bottom-4 right-4 bg-green-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 z-50">
        <span>App ready for offline use!</span>
        <button onClick={close} className="text-white hover:underline">
          Close
        </button>
      </div>
    );
  }

  if (needRefresh) {
    return (
      <div className="fixed bottom-4 right-4 bg-blue-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 z-50">
        <span>New version available!</span>
        <button
          onClick={updateAndReload}
          className="bg-white text-blue-600 px-3 py-1 rounded hover:bg-gray-100"
        >
          Reload
        </button>
        <button onClick={close} className="text-white hover:underline">
          Later
        </button>
      </div>
    );
  }

  return null;
}
